import type { AdressAnsicht } from "@kundeninfo/api-client";

/**
 * Adressen als Text und in der Reihenfolge der Auswahl — gemeinsam für die Belegparteien
 * (components/BelegParteien.tsx) und die Rechnungsangaben der Kundenbeziehung
 * (views/BeziehungRechnungsangaben.tsx).
 */

/** Eine Adresse als Text in EINER Zeile — für Auswahlzeilen und Vorgabe-Hinweise.
 *  `zeilen` kommt fertig vom Server, `value` bei Arten ohne Postanschrift (E-Mail, ILN). */
export function alsText(a: AdressAnsicht): string {
  return a.zeilen.length > 0 ? a.zeilen.join(", ") : (a.value ?? "");
}

/** Eine Auswahlzeile: Etikett, Anschrift — und bei einer geerbten, von wem sie kommt. */
export function alsEintrag(a: AdressAnsicht): string {
  const etikett = a.label === null || a.label === "" ? "" : `${a.label}: `;
  const herkunft = a.origin === null ? "" : ` — von ${a.origin.companyName}`;
  return `${etikett}${alsText(a)}${herkunft}`;
}

/**
 * Die Reihenfolge der Auswahl (Hausregel „das Wichtigste oben"): die Hauptadressen zuerst —
 * mit `rolle` nur die Hauptadresse DIESER Rolle, ohne die Hauptadresse jeder Rolle —, dann die
 * übrigen eigenen, dann die geerbten in der Reihenfolge der Kette, die der Server liefert.
 *
 * Erst nach Herkunft teilen, dann je Teil die Hauptadressen hochziehen — nicht umgekehrt:
 * Sonst verdrängte eine geerbte Hauptadresse eine eigene Nebenadresse (dieselbe Lehre wie
 * `eigeneZuerst` in views/AdressListe.tsx).
 */
export function geordnet(liste: readonly AdressAnsicht[], rolle?: string): AdressAnsicht[] {
  const vorn = (a: AdressAnsicht): boolean => a.isPrimary && (rolle === undefined || a.role === rolle);
  const haupt = (l: AdressAnsicht[]): AdressAnsicht[] => [...l.filter(vorn), ...l.filter((a) => !vorn(a))];
  return [...haupt(liste.filter((a) => a.origin === null)), ...haupt(liste.filter((a) => a.origin !== null))];
}
